export const  parkLayerSettings= {
    parkLayerDefer: null,
    parkLayerPromise: null,
    activeParks: {
      styles: {
        hover: {
          fillOpacity: 0.7,
          fillColor: '#4d7c28',
          strokeColor: '#ffffff',
          strokeWeight: 0,
          strokeOpacity: 0,
          zIndex: -1,
        },
        selected: {
          fillOpacity: 0.7,
          fillColor: '#4d7c28',
          strokeColor: '#ffffff',
          strokeWeight: 1,
          strokeOpacity: 1,
          zIndex: -1,
        },
        clickedActive: {
          fillOpacity: 0.7,
          fillColor: '#4d7c28',
          fillColor: 'red',
          strokeColor: '#ffffff',
          strokeWeight: 1,
          strokeOpacity: 1,
          zIndex: -1,
        },
        defaultState: {
          fillOpacity: 0.01,
          fillColor: '#4d7c28',
          strokeColor: '#ffffff',
          strokeWeight: 1,
          strokeOpacity: 0,
          zIndex: -1,
        },
      },
    },
    inactiveParks: {
      styles: {
        closed: {
          fillColor: '#2b2b2b',
          fillOpacity: 0.7,
        },
        partialClosed: {
          fillColor: '#006881',
          fillOpacity: 0.7,
        },
        fire: {
          fillColor: '#ef7b08',
          fillOpacity: 0.7,
        },
        visible: {
          zIndex: 1,
          fillOpacity: 1,
        },
        hidden: {
          zIndex: 0,
          fillOpacity: 0,
        },
        hover: {
          fillOpacity: 0.7,
          fillColor: '#4d7c28',
          strokeColor: '#ffffff',
          strokeWeight: 1,
          strokeOpacity: 1,
          zIndex: 2,
        },
        selected: {
          fillOpacity: 0.7,
          //fillColor: '#4d7c28',
          fillColor: '#0000FF',
          strokeColor: '#ffffff',
          strokeWeight: 1,
          strokeOpacity: 0,
          zIndex: 1,
        },
        defaultState: {
          fillOpacity: 0.4,
          fillColor: '#4d7c28',
          strokeColor: '#ffffff',
          strokeWeight: 1,
          strokeOpacity: 1,
          zIndex: 1,
        },
      },
    },
  };